<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير فارس الاسبوع'" :to="{name: 'reports.weekDegree'}">  تقرير فارس الاسبوع</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تقرير فارس الاسبوع
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-6 mt-2">
                                          <label for="">التاريخ من <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                          <label for="">التاريخ إلى <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4 mt-2">
                                          <label for="">المرحلة الدراسية</label>
                                          <treeselect :options="stages" v-model="data.searching.stage_id" @select="getGroups($event); getLessons($event, 'stage')" :multiple="false" />
                                        </div>
                                        <div class="col-md-4 mt-2">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" @select="getLessons" :multiple="false" />
                                        </div>
                                        <div class="col-md-4 mt-2">
                                          <label for="">الحلقة <span class="text-danger">*</span></label>
                                          <treeselect :options="lessons" v-model="data.searching.lesson_id" @select="getStudents" :multiple="false" />
                                        </div>
                                        
                                        <div class="col-md-4 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                
                                <div class="col-md-12" >
                                  <div class="col-md-12">
                                  <button class="btn btn-success" v-if="gotData" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  <button class="btn btn-success ml-2" v-if="(gotData)" @click.prevent="exportFarisWeeklyExcel">
                                    تصدير Excel
                                  </button>
                                </div>  
                                    <div class="table-responsive" id="printMe">
                                          <table class="table table-bordered mb-4" v-if="gotData">
                                              <thead>
                                                  <tr>
                                                    <th>اسم التقرير</th>
                                                    <th> التاريخ من</th>
                                                    <th> التاريخ إلى</th>
                                                    <th>المرحلة الدراسية</th>
                                                    <th>الصف الدراسى</th>
                                                    <th>الحلقة</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                               <tr>
                                                <td> تقرير فارس الاسبوع</td>
                                                <td>{{ data.searching.date_from }}</td>
                                                <td>{{ data.searching.date_to }}</td>
                                                <td>{{ getLabelById(stages, data.searching.stage_id) }}</td>
                                                <td>{{ getLabelById(groups, data.searching.group_id) }}</td>
                                                <td>{{ getLabelById(lessons, data.searching.lesson_id) }}</td>
                                               </tr>
                                              </tbody>
                                          </table>
                                          <table class="table table-bordered mb-4" v-if="data.data.length && gotData">
                                              <thead>
                                                  <tr>
                                                    <th>التاريخ</th>
                                                    <th>الطالب</th>
                                                    <th>الدرجة</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                <tr v-for="(item, k) in data.data" :key="k">
                                                  <td>{{ item.date }}</td>
                                                  <td>{{ item.student }}</td>
                                                  <td>{{ item.degree }}</td>
                                                </tr>
                                           
                                              </tbody>
                                          </table>
                                          <table class="table table-bordered mb-4" v-if="!data.data.length && gotData">
                                              <thead>
                                                  <tr>
                                                    <th>التاريخ</th>
                                                    <th>الطالب</th>
                                                    <th>الدرجة</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td colspan="6">لا يوجد بيانات</td>
                                                </tr>
                                           
                                              </tbody>
                                          </table>
                                          
                                </div>
                                </div>
                               
                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as XLSX from "xlsx";
export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
     gotData: false,
      printData: {
      },
      data: {
        data: {},
        searching:{
            stage_id: '',
            group_id: '',
            lesson_id: '',
            student_id: '',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.search(null, '', this, 'stage');
      this.search(null, '', this, 'lesson');
      this.search(null, '', this, 'group');
  },
  methods: {
     exportFarisWeeklyExcel() {
      const wb = XLSX.utils.book_new();
      const self = this;

      // =========================
      // Safe Excel sheet name
      // =========================
      function safeSheetName(name) {
        if (!name) return "تقرير فارس الأسبوع";
        return name.toString().replace(/[\[\]\*\/\\\?\:]/g, "").substring(0, 31);
      }

      const rows = [];

      // ===== Header info table =====
      rows.push([
        "اسم التقرير",
        "التاريخ من",
        "التاريخ إلى",
        "المرحلة الدراسية",
        "الصف الدراسى",
        "الحلقة"
      ]);

      rows.push([
        "تقرير فارس الأسبوع",
        self.data.searching.date_from,
        self.data.searching.date_to,
        self.getLabelById(self.stages, self.data.searching.stage_id),
        self.getLabelById(self.groups, self.data.searching.group_id),
        self.getLabelById(self.lessons, self.data.searching.lesson_id)
      ]);

      rows.push([]); // empty row

      // ===== Data table =====
      rows.push(["التاريخ", "الطالب", "الدرجة"]);

      if (Array.isArray(self.data.data) && self.data.data.length > 0) {
        self.data.data.forEach(function (item) {
          rows.push([
            item.date,
            item.student,
            item.degree
          ]);
        });
      } else {
        // No data case
        rows.push(["لا يوجد بيانات", "", ""]);
      }

      // ===== Create worksheet =====
      const ws = XLSX.utils.aoa_to_sheet(rows);

      // RTL support
      ws["!rtl"] = true;

      // Column widths (adjust as needed)
      ws["!cols"] = [
        { wch: 15 },
        { wch: 25 },
        { wch: 10 }
      ];

      // Append sheet
      XLSX.utils.book_append_sheet(wb, ws, safeSheetName("Faris Weekly"));

      // Save file
      XLSX.writeFile(wb, "faris-weekly-report.xlsx");
    },
    getLabelById(arr, id){
      if(arr.length){
        for (let index = 0; index < arr.length; index++) {
        let element = arr[index];
        if(element.id == id){
          return element.label;
        }
        
      }
      }
      
      return '';
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', ' تقرير فارس الاسبوع');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/reports/absences?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
              if(type == 'student'){
                this.students = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/reports/absences?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    
    getLessons(val, type = 'group'){
      var param = type+'=' + (type == 'group' ? this.data.searching.group_id : val.id);
      this.$baseApi.get('/reports/week-degree?pluck=1&'+param+'&i='+val.id+'&pluckType=lesson').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lessons = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStudents(val){
      this.$baseApi.get('/reports/absences?pluck=1&lesson='+this.data.searching.lesson_id+'&i='+val.id+'&pluckType=student').then((response)=>{
            
            if(response.data.code == 200){
              
              this.students = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        if(this.data.searching.date_from == '' || this.data.searching.date_to == '' || this.data.searching.lesson_id == ''){
          return;
        }
        this.gotData = false;
        this.$baseApi.get('/reports/week-degree?data=' + 1, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.data = response.data.data.data;
              this.gotData = true;
          

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return (n/t) * 100;
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
